// // import React, { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { toast } from "react-toastify";
// // import authService from "../services/authService";

// // const Login = () => {
// //   const navigate = useNavigate();
// //   const [username, setUsername] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [loading, setLoading] = useState(false);

// //   useEffect(() => {
// //     // If user is already logged in, redirect to dashboard
// //     if (authService.getToken() && authService.getCurrentUser()) {
// //       navigate("/dashboard");
// //     }
// //   }, [navigate]);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!username || !password) {
// //       toast.error("Please fill in both Username and Password.");
// //       return;
// //     }

// //     try {
// //       setLoading(true);
// //       const res = await authService.login(username, password);
// //       if (res && res.success) {
// //         toast.success(res.message || "Login successful! Welcome back.");
// //         navigate("/dashboard");
// //       } else {
// //         toast.error(res.message || "Invalid credentials.");
// //       }
// //     } catch (error) {
// //       const errMsg =
// //         error.response?.data?.message || "Login failed. Please check your credentials.";
// //       toast.error(errMsg);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div
// //       className="d-flex align-items-center justify-content-center min-vh-100"
// //       style={{
// //         background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)"
// //       }}
// //     >
// //       <div className="container">
// //         <div className="row justify-content-center">
// //           <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
// //             <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
// //               <div className="card-header bg-primary text-white text-center py-4 border-0">
// //                 <div className="fs-1 mb-1">🎰</div>
// //                 <h3 className="fw-bold mb-0">Casino Admin</h3>
// //                 <small className="text-white-50">Management Portal Login</small>
// //               </div>
// //               <div className="card-body p-4 p-sm-5 bg-white">
// //                 <form onSubmit={handleSubmit}>
// //                   <div className="mb-4">
// //                     <label className="form-label fw-semibold text-dark">
// //                       Username
// //                     </label>
// //                     <div className="input-group">
// //                       <span className="input-group-text bg-light border-end-0">
// //                         <i className="bi bi-person-fill text-muted"></i>
// //                       </span>
// //                       <input
// //                         type="text"
// //                         className="form-control bg-light border-start-0 py-2"
// //                         placeholder="Enter your username"
// //                         value={username}
// //                         onChange={(e) => setUsername(e.target.value)}
// //                         required
// //                         disabled={loading}
// //                       />
// //                     </div>
// //                   </div>

// //                   <div className="mb-4">
// //                     <label className="form-label fw-semibold text-dark">
// //                       Password
// //                     </label>
// //                     <div className="input-group">
// //                       <span className="input-group-text bg-light border-end-0">
// //                         <i className="bi bi-lock-fill text-muted"></i>
// //                       </span>
// //                       <input
// //                         type="password"
// //                         className="form-control bg-light border-start-0 py-2"
// //                         placeholder="Enter your password"
// //                         value={password}
// //                         onChange={(e) => setPassword(e.target.value)}
// //                         required
// //                         disabled={loading}
// //                       />
// //                     </div>
// //                   </div>

// //                   <button
// //                     type="submit"
// //                     className="btn btn-primary w-100 py-3 fw-bold shadow-sm rounded-3 mt-2"
// //                     disabled={loading}
// //                   >
// //                     {loading ? (
// //                       <>
// //                         <span
// //                           className="spinner-border spinner-border-sm me-2"
// //                           role="status"
// //                           aria-hidden="true"
// //                         ></span>
// //                         Signing in...
// //                       </>
// //                     ) : (
// //                       "Sign In"
// //                     )}
// //                   </button>
// //                 </form>
// //               </div>
// //               <div className="card-footer text-center py-3 bg-light border-0">
// //                 <small className="text-muted">
// //                   Secured Casino Admin Panel System &copy; 2026
// //                 </small>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;



// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import authService from "../services/authService";

// const Login = () => {
//   const navigate = useNavigate();

//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (authService.getToken() && authService.getCurrentUser()) {
//       navigate("/dashboard");
//     }
//   }, [navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!username || !password) {
//       toast.error("Please fill in both Username and Password.");
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await authService.login(username, password);

//       if (res?.success) {
//         toast.success(res.message || "Login successful!");
//         navigate("/dashboard");
//       } else {
//         toast.error(res?.message || "Invalid credentials.");
//       }
//     } catch (error) {
//       toast.error(
//         error.response?.data?.message ||
//         "Login failed. Please check your credentials."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="relative h-screen w-screen overflow-hidden bg-[#070A12] flex items-center justify-center p-4">
//       {/* Background Glow Accents */}
//       <div className="pointer-events-none absolute -left-20 -top-20 h-80 w-80 rounded-full bg-[#D4AF37]/5 blur-3xl" />
//       <div className="pointer-events-none absolute -bottom-20 -right-20 h-80 w-80 rounded-full bg-[#D4AF37]/5 blur-3xl" />

//       {/* Main Container */}
//       <div className="relative z-10 w-full max-w-md">
//         <div className="overflow-hidden rounded-2xl border border-[rgba(148,163,184,0.14)] bg-[#121827] shadow-2xl">

//           {/* Header */}
//           <div className="border-b border-[rgba(148,163,184,0.14)] bg-[#0D111C] px-6 py-6 text-center">
//             <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-2xl text-[#D4AF37]">
//               ♠
//             </div>

//             <h1 className="text-xl font-bold tracking-tight text-[#F8FAFC]">
//               Casino Admin
//             </h1>

//             <p className="mt-1 text-xs text-[#94A3B8]">
//               Management Portal Login
//             </p>
//           </div>

//           {/* Form */}
//           <div className="px-6 py-6 sm:px-8">
//             <form onSubmit={handleSubmit} className="space-y-4">

//               {/* Username */}
//               <div>
//                 <label className="mb-1.5 block text-xs font-semibold text-[#CBD5E1]">
//                   Username
//                 </label>

//                 <div className="group relative">
//                   <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5">
//                     <i className="bi bi-person-fill text-[#64748B] transition group-focus-within:text-[#D4AF37]" />
//                   </div>

//                   <input
//                     type="text"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     placeholder="Enter your username"
//                     disabled={loading}
//                     autoComplete="username"
//                     className="h-11 w-full rounded-lg border border-[rgba(148,163,184,0.2)] bg-[#0D111C] pl-10 pr-4 text-xs text-[#F8FAFC] outline-none transition placeholder:text-[#64748B] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]/30 disabled:cursor-not-allowed disabled:opacity-60"
//                   />
//                 </div>
//               </div>

//               {/* Password */}
//               <div>
//                 <label className="mb-1.5 block text-xs font-semibold text-[#CBD5E1]">
//                   Password
//                 </label>

//                 <div className="group relative">
//                   <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5">
//                     <i className="bi bi-lock-fill text-[#64748B] transition group-focus-within:text-[#D4AF37]" />
//                   </div>

//                   <input
//                     type={showPassword ? "text" : "password"}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     placeholder="Enter your password"
//                     disabled={loading}
//                     autoComplete="current-password"
//                     className="h-11 w-full rounded-lg border border-[rgba(148,163,184,0.2)] bg-[#0D111C] pl-10 pr-10 text-xs text-[#F8FAFC] outline-none transition placeholder:text-[#64748B] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]/30 disabled:cursor-not-allowed disabled:opacity-60"
//                   />

//                   <button
//                     type="button"
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-[#64748B] transition hover:text-[#F8FAFC]"
//                   >
//                     <i
//                       className={`bi ${showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
//                         }`}
//                     />
//                   </button>
//                 </div>
//               </div>

//               {/* Submit Button */}
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="mt-2 flex h-11 w-full items-center justify-center rounded-lg bg-[#D4AF37] text-xs font-bold text-[#070A12] transition hover:bg-[#F4D77A] disabled:cursor-not-allowed disabled:opacity-60"
//               >
//                 {loading ? (
//                   <>
//                     <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-[#070A12]/30 border-t-[#070A12]" />
//                     Signing in...
//                   </>
//                 ) : (
//                   <>
//                     <i className="bi bi-box-arrow-in-right mr-2" />
//                     Sign In
//                   </>
//                 )}
//               </button>
//             </form>
//           </div>

//           {/* Footer */}
//           <div className="border-t border-[rgba(148,163,184,0.14)] bg-[#0D111C] px-5 py-3 text-center">
//             <p className="m-0 text-[11px] text-[#64748B]">
//               Secured Casino Management System © 2026
//             </p>
//           </div>
//         </div>

//         <p className="mt-3 text-center text-[10px] text-[#64748B]">
//           Authorized access only
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;





import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import authService from "../services/authService";
import computerAuthService from "../services/computerAuthService";

const Login = () => {
  const navigate = useNavigate();

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState("");

  // ============================================================
  // EXISTING STAFF SESSION
  // ============================================================

  useEffect(() => {
    if (
      authService.getToken() &&
      authService.getCurrentUser()
    ) {
      navigate("/dashboard");
    }
  }, [navigate]);

  // ============================================================
  // COMPUTER SESSION SAVE
  // ============================================================

  const saveComputerSession = (response) => {
    sessionStorage.setItem(
      "computer_token",
      response.token
    );

    sessionStorage.setItem(
      "computer",
      JSON.stringify(response.computer)
    );

    localStorage.setItem(
      "computer_token",
      response.token
    );

    localStorage.setItem(
      "computer",
      JSON.stringify(response.computer)
    );
  };

  // ============================================================
  // TRY STAFF LOGIN
  // ============================================================

  const tryStaffLogin = async () => {
    try {
      const response = await authService.login(
        loginId.trim(),
        password
      );

      if (response?.success) {
        return {
          success: true,
          type: "STAFF",
          response,
        };
      }

      return {
        success: false,
      };
    } catch (error) {
      /*
        Staff credentials may simply not exist because this
        could be a Computer ID.

        So we continue to Computer authentication.
      */

      return {
        success: false,
        error,
      };
    }
  };

  // ============================================================
  // TRY COMPUTER LOGIN
  // ============================================================

  const tryComputerLogin = async () => {
    try {
      const response =
        await computerAuthService.login(
          loginId,
          password
        );

      if (response?.success) {
        return {
          success: true,
          type: "COMPUTER",
          response,
        };
      }

      return {
        success: false,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  };

  // ============================================================
  // LOGIN
  // ============================================================

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cleanLoginId = loginId.trim();

    if (!cleanLoginId || !password) {
      toast.error(
        "Please enter your Username / Computer ID and Password."
      );

      return;
    }

    try {
      setLoading(true);

      // ========================================================
      // 1. TRY STAFF
      // ========================================================

      const staffResult =
        await tryStaffLogin();

      if (staffResult.success) {
        // Clear any leftover computer session from storage
        sessionStorage.removeItem("computer_token");
        sessionStorage.removeItem("computer");
        localStorage.removeItem("computer_token");
        localStorage.removeItem("computer");

        toast.success(
          staffResult.response?.message ||
          "Login successful!"
        );

        navigate("/dashboard");

        return;
      }

      // ========================================================
      // 2. TRY COMPUTER
      // ========================================================

      const computerResult =
        await tryComputerLogin();

      if (computerResult.success) {
        // Clear any leftover staff session from storage
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        saveComputerSession(
          computerResult.response
        );

        toast.success(
          computerResult.response?.message ||
          "Computer login successful!"
        );

        sessionStorage.removeItem("pc_disclaimer_accepted");
        navigate("/computer-dashboard");
        return;
      }

      // ========================================================
      // BOTH FAILED
      // ========================================================

      const computerErrorMessage =
        computerResult.error?.response?.data
          ?.message;

      /*
        Important device-binding errors ko generic
        invalid credentials me hide nahi karenge.
      */

      if (
        computerErrorMessage ===
        "This Computer ID is bound to another device." ||
        computerErrorMessage ===
        "This Computer is blocked." ||
        computerErrorMessage ===
        "Shop account is blocked."
      ) {
        toast.error(computerErrorMessage);

        return;
      }

      toast.error(
        "Invalid Username / Computer ID or Password."
      );
    } catch (error) {
      console.error("Login Error:", error);

      toast.error(
        "Unable to sign in. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-[#05070D] px-4 py-8">

      {/* ====================================================== */}
      {/* CSS ANIMATIONS */}
      {/* ====================================================== */}

      <style>{`
        @keyframes loginFloat {
          0%, 100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-12px);
          }
        }

        @keyframes loginGlow {
          0%, 100% {
            opacity: 0.25;
            transform: scale(1);
          }

          50% {
            opacity: 0.55;
            transform: scale(1.12);
          }
        }

        @keyframes loginCardEnter {
          from {
            opacity: 0;
            transform:
              translateY(25px)
              scale(0.97);
          }

          to {
            opacity: 1;
            transform:
              translateY(0)
              scale(1);
          }
        }

        @keyframes loginShine {
          0% {
            transform: translateX(-160%);
          }

          100% {
            transform: translateX(250%);
          }
        }

        @keyframes loginGridMove {
          from {
            transform: translateY(0);
          }

          to {
            transform: translateY(44px);
          }
        }

        @keyframes loginPulse {
          0%, 100% {
            box-shadow:
              0 0 0 0 rgba(212, 175, 55, 0);
          }

          50% {
            box-shadow:
              0 0 30px 2px rgba(212, 175, 55, 0.08);
          }
        }

        .login-card-animation {
          animation:
            loginCardEnter 0.65s ease-out both,
            loginPulse 4s ease-in-out 1s infinite;
        }

        .login-logo-animation {
          animation:
            loginFloat 4s ease-in-out infinite;
        }

        .login-glow-animation {
          animation:
            loginGlow 7s ease-in-out infinite;
        }

        .login-grid-animation {
          animation:
            loginGridMove 5s linear infinite;
        }

        .login-button-shine {
          position: relative;
          overflow: hidden;
        }

        .login-button-shine::after {
          content: "";
          position: absolute;
          top: -50%;
          left: 0;
          width: 35%;
          height: 200%;
          transform: translateX(-160%);
          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,0.32),
              transparent
            );
        }

        .login-button-shine:hover::after {
          animation:
            loginShine 0.8s ease;
        }
      `}</style>

      {/* ====================================================== */}
      {/* BACKGROUND GRID */}
      {/* ====================================================== */}

      <div className="pointer-events-none absolute inset-0 overflow-hidden opacity-[0.035]">

        <div
          className="login-grid-animation absolute -inset-[50px]"
          style={{
            backgroundImage: `
              linear-gradient(
                rgba(212,175,55,0.35) 1px,
                transparent 1px
              ),
              linear-gradient(
                90deg,
                rgba(212,175,55,0.35) 1px,
                transparent 1px
              )
            `,

            backgroundSize: "44px 44px",
          }}
        />

      </div>

      {/* ====================================================== */}
      {/* BACKGROUND GLOWS */}
      {/* ====================================================== */}

      <div className="pointer-events-none absolute inset-0">

        <div className="login-glow-animation absolute -left-40 -top-40 h-[500px] w-[500px] rounded-full bg-[#D4AF37]/10 blur-[120px]" />

        <div
          className="login-glow-animation absolute -bottom-52 -right-40 h-[550px] w-[550px] rounded-full bg-[#D4AF37]/[0.07] blur-[130px]"
          style={{
            animationDelay: "2s",
          }}
        />

        <div className="absolute left-1/2 top-1/2 h-[350px] w-[350px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#D4AF37]/[0.025] blur-[100px]" />

      </div>

      {/* ====================================================== */}
      {/* LOGIN WRAPPER */}
      {/* ====================================================== */}

      <div className="relative z-10 w-full max-w-[430px]">

        {/* ==================================================== */}
        {/* BRAND */}
        {/* ==================================================== */}

        <div className="mb-6 text-center">

          <div className="login-logo-animation mx-auto flex h-[66px] w-[66px] items-center justify-center rounded-2xl border border-[#D4AF37]/30 bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5 text-[30px] text-[#D4AF37] shadow-[0_15px_45px_rgba(212,175,55,0.12)]">

            ♠

          </div>

          <h1 className="mt-4 text-[26px] font-black tracking-tight text-[#F8FAFC]">

            Management Portal

          </h1>

          <div className="mt-2 flex items-center justify-center gap-2">

            <span className="h-px w-8 bg-gradient-to-r from-transparent to-[#D4AF37]/50" />

            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#D4AF37]">

              Secure Access

            </span>

            <span className="h-px w-8 bg-gradient-to-l from-transparent to-[#D4AF37]/50" />

          </div>

        </div>

        {/* ==================================================== */}
        {/* CARD */}
        {/* ==================================================== */}

        <div className="login-card-animation overflow-hidden rounded-[24px] border border-[rgba(212,175,55,0.18)] bg-[#101520]/95 shadow-[0_30px_80px_rgba(0,0,0,0.5)] backdrop-blur-xl">

          {/* TOP GOLD LINE */}

          <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

          {/* ================================================== */}
          {/* CARD HEADER */}
          {/* ================================================== */}

          <div className="border-b border-white/[0.06] px-7 pb-5 pt-7">

            <div className="flex items-center gap-3.5">

              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-[#D4AF37]/20 bg-[#D4AF37]/10 text-[#D4AF37]">

                <i className="bi bi-shield-lock-fill text-lg" />

              </div>

              <div>

                <h2 className="text-base font-extrabold text-[#F8FAFC]">

                  Sign in to continue

                </h2>

                <p className="mt-1 text-[11px] text-[#64748B]">

                  Use your Username or Computer ID

                </p>

              </div>

            </div>

          </div>

          {/* ================================================== */}
          {/* FORM */}
          {/* ================================================== */}

          <div className="px-7 py-7">

            <form
              onSubmit={handleSubmit}
              className="space-y-5"
            >

              {/* ================================================= */}
              {/* LOGIN ID */}
              {/* ================================================= */}

              <div>

                <label className="mb-2 block text-[11px] font-bold uppercase tracking-wider text-[#94A3B8]">

                  Username / Computer ID

                </label>

                <div
                  className={`group relative rounded-xl transition-all duration-300 ${focusedField === "login"
                      ? "shadow-[0_0_0_3px_rgba(212,175,55,0.08)]"
                      : ""
                    }`}
                >

                  <div className="pointer-events-none absolute inset-y-0 left-0 flex w-12 items-center justify-center">

                    <i
                      className={`bi bi-person-badge-fill transition-all duration-300 ${focusedField === "login"
                          ? "scale-110 text-[#D4AF37]"
                          : "text-[#64748B]"
                        }`}
                    />

                  </div>

                  <input
                    type="text"
                    value={loginId}
                    onChange={(event) =>
                      setLoginId(
                        event.target.value
                      )
                    }
                    onFocus={() =>
                      setFocusedField("login")
                    }
                    onBlur={() =>
                      setFocusedField("")
                    }
                    placeholder="Username or PC-04"
                    disabled={loading}
                    autoComplete="username"
                    autoFocus
                    className="h-[52px] w-full rounded-xl border border-white/[0.09] bg-[#090D15] pl-12 pr-4 text-sm font-medium text-[#F8FAFC] outline-none transition-all duration-300 placeholder:text-[#3F4A5D] hover:border-white/[0.14] focus:border-[#D4AF37]/70 disabled:cursor-not-allowed disabled:opacity-50"
                  />

                </div>

              </div>

              {/* ================================================= */}
              {/* PASSWORD */}
              {/* ================================================= */}

              <div>

                <label className="mb-2 block text-[11px] font-bold uppercase tracking-wider text-[#94A3B8]">

                  Password

                </label>

                <div
                  className={`group relative rounded-xl transition-all duration-300 ${focusedField === "password"
                      ? "shadow-[0_0_0_3px_rgba(212,175,55,0.08)]"
                      : ""
                    }`}
                >

                  <div className="pointer-events-none absolute inset-y-0 left-0 flex w-12 items-center justify-center">

                    <i
                      className={`bi bi-lock-fill transition-all duration-300 ${focusedField === "password"
                          ? "scale-110 text-[#D4AF37]"
                          : "text-[#64748B]"
                        }`}
                    />

                  </div>

                  <input
                    type={
                      showPassword
                        ? "text"
                        : "password"
                    }
                    value={password}
                    onChange={(event) =>
                      setPassword(
                        event.target.value
                      )
                    }
                    onFocus={() =>
                      setFocusedField(
                        "password"
                      )
                    }
                    onBlur={() =>
                      setFocusedField("")
                    }
                    placeholder="Enter your password"
                    disabled={loading}
                    autoComplete="current-password"
                    className="h-[52px] w-full rounded-xl border border-white/[0.09] bg-[#090D15] pl-12 pr-12 text-sm font-medium text-[#F8FAFC] outline-none transition-all duration-300 placeholder:text-[#3F4A5D] hover:border-white/[0.14] focus:border-[#D4AF37]/70 disabled:cursor-not-allowed disabled:opacity-50"
                  />

                  <button
                    type="button"
                    disabled={loading}
                    onClick={() =>
                      setShowPassword(
                        (previous) =>
                          !previous
                      )
                    }
                    className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-[#64748B] transition hover:text-[#D4AF37]"
                    aria-label={
                      showPassword
                        ? "Hide password"
                        : "Show password"
                    }
                  >

                    <i
                      className={`bi ${showPassword
                          ? "bi-eye-slash-fill"
                          : "bi-eye-fill"
                        }`}
                    />

                  </button>

                </div>

              </div>

              {/* ================================================= */}
              {/* SECURITY INFO */}
              {/* ================================================= */}

              <div className="flex items-center gap-2.5 rounded-xl border border-white/[0.06] bg-[#090D15]/70 px-3.5 py-3">

                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#22C55E]/10 text-[#22C55E]">

                  <i className="bi bi-shield-check text-xs" />

                </div>

                <p className="m-0 text-[10px] leading-[17px] text-[#64748B]">

                  Secure authentication for authorized
                  staff and registered computers.

                </p>

              </div>

              {/* ================================================= */}
              {/* SIGN IN */}
              {/* ================================================= */}

              <button
                type="submit"
                disabled={loading}
                className="login-button-shine group flex h-[52px] w-full items-center justify-center rounded-xl bg-gradient-to-r from-[#D4AF37] via-[#E3C258] to-[#B88A20] text-xs font-black uppercase tracking-[0.12em] text-[#070A12] shadow-[0_10px_30px_rgba(212,175,55,0.15)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(212,175,55,0.22)] active:translate-y-0 disabled:cursor-not-allowed disabled:opacity-60"
              >

                {loading ? (
                  <>
                    <span className="mr-2.5 h-4 w-4 animate-spin rounded-full border-2 border-[#070A12]/25 border-t-[#070A12]" />

                    Signing In
                  </>
                ) : (
                  <>
                    <span>
                      Sign In
                    </span>

                    <i className="bi bi-arrow-right ml-2 text-base transition-transform duration-300 group-hover:translate-x-1" />
                  </>
                )}

              </button>

            </form>

          </div>

          {/* ================================================== */}
          {/* FOOTER */}
          {/* ================================================== */}

          <div className="border-t border-white/[0.06] bg-[#090D15]/60 px-6 py-4">

            <div className="flex items-center justify-center gap-2">

              <span className="relative flex h-2 w-2">

                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#22C55E] opacity-40" />

                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#22C55E]" />

              </span>

              <span className="text-[10px] font-medium text-[#64748B]">

                Secure Management System

              </span>

            </div>

          </div>

        </div>

        {/* ==================================================== */}
        {/* BOTTOM */}
        {/* ==================================================== */}

        <p className="mt-4 text-center text-[10px] text-[#3F4A5D]">

          Authorized access only · ©{" "}
          {new Date().getFullYear()}

        </p>

      </div>

    </div>
  );
};

export default Login;